package hk.com.vr360_demo2.webapp.component.home

import cc.easyandroid.easycompose.component.ComponentContext
import cc.easyandroid.easycompose.component.router.webhistory.WebNavigation
import cc.easyandroid.easycompose.component.router.webhistory.WebNavigationOwner

interface HomeComponent {
    val token: String?

}

class DefaultHomeComponent(

    context: ComponentContext, override val token: String?,

    ) : HomeComponent {
}